// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-point-presenter[data-v-b465b318]{margin-top:20px;margin-bottom:20px}.total-point[data-v-b465b318]{font-size:20px;font-weight:700;text-align:center;margin-bottom:20px}.point-list[data-v-b465b318]{margin:auto;max-width:400px;width:95%}", ""]);
// Exports
module.exports = exports;
